module.exports = __webpack_public_path__ + "static/media/green_tick.04340033.svg";